module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/bg_racemsg-bfa041d44990b0e0b5451153f73d6848.jpg";